var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfusionsoft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6385 14.9881H3.84696C3.55422 14.9881 3.39014 14.8232 3.39014 14.5295V1.45865C3.39014 1.16495 3.55508 1 3.84696 1H5.63807C5.93134 1 6.09532 1.16495 6.09532 1.45865V5.73598H12.1455C12.4382 5.73598 12.6023 5.90179 12.6023 6.19506V8.01216C12.6023 8.30586 12.4378 8.47081 12.1455 8.47081H8.03312L12.4566 12.9131C12.6573 13.116 12.6573 13.3548 12.4566 13.5747L11.2135 14.8415C11.0119 15.0619 10.7567 15.0435 10.5551 14.8415L6.09532 10.3625V14.5295C6.09532 14.8232 5.93124 14.9881 5.6385 14.9881Z",
    fill: "#36A635"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfusionsoft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Infusionsoft.22296af7f148b94ec2d9f24d7278392e.svg";